import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useReleaseRoyaltySchema = () => {
    const { t } = useTranslation();

    return yup.object({
        track: yup.string().required(t("messages.inputMsgs.required")),
    });
};

export default useReleaseRoyaltySchema;
